export const api_url = "https://api.erp-isor.com/api";
export const api_file_url = "https://api.erp-isor.com/public/";
//export const api_file_url_catalogue = `${api_file_url}product/`;
export const api_file_url_catalogue = ``;
export const api_file_url_cmd_fb = `${api_file_url}cmd-fb/`;
export const api_file_url_passport = `${api_file_url}passport/`;
export const token_name = "isor-token";
export const mg_token_name = "isor-mg-token";
export const user_data_name = "isor-user";